import { useQuery } from '@tanstack/vue-query';
import type { Ref } from 'vue';

import capitalMarketsService from '../services/capitalMarketsService';
import type { GetBlocklistRequest } from '../services/capitalMarketsService';

export default function useBlocklist(params: Ref<GetBlocklistRequest>) {
  return useQuery({
    queryKey: ['financing-blocklist', params],
    queryFn: () => capitalMarketsService.getBlocklist(params.value),
  });
}
